import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getAll(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getusers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/dropdown/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}


async function getTableData(payload) {
    const resultdata = await axios.post(apiUrl + "/log/trade",payload,{
        headers: jsonHeader}
    );

    return resultdata.data || [];
}
export const TradeLogServices = {
    getAll,
    getusers,
    getTableData
}